export default [
    '3bb55c8e-c6cd-46bc-aa82-ede080cbe92a',
    'fa6761cc-c278-48b7-8b40-31824ae0cbc5',
    '6a6f4623-6219-4973-bb81-098cc7bc4d98',
    '90c532eb-ddde-4f1c-8379-7d2a4d8d90e7',
    'd9ecbd04-96be-4bd5-af32-4f07ccbfccc3',
    '269ca46f-9e20-477d-a50b-84173e5d171e',
    '0ba48840-899b-4e23-9429-9456094bf1f1',
    '027b66d5-5f50-4dbb-bc0c-b16a94e0877f',
    '081544df-36a6-40a7-a821-8dc84a1a7aa0',
    '7d732b5f-1a3d-4d1c-96ea-d205bd233467',
    '0d7e691a-65ad-4f37-9ec7-973d18c9a427',
    '3aa9e4b5-3302-4536-aeae-178853fa348a',
    '0e22141d-9ad8-46ee-94d3-ab77b95aceba',
    '1f4791e9-d6bd-4108-a19b-a691b2f5a3d9',
    'b8310279-3d04-4b05-8fca-abf5cdafd70f',
    'c3478f20-57c1-4280-81ad-55a8c4054f37',
    '59595148-c2b4-4bc7-8b1e-9d0d36587b67',
    '3627ef32-899b-4bdb-bbc6-aefdc027002b',
    '920478eb-d547-40e4-8d1c-6478c8409bcb',
    'e5aa352c-4fa5-491f-b457-4118cc2d8d56',
    'e8722077-7590-4bac-b49c-2229c888616b',
    '4d5383dc-5191-4d8a-8927-fdc918f4637c',
    'd7bd0c82-936c-421e-998a-1d846cdacb0a',
    '6544e151-ccf6-46a5-825c-df4873e41f5e',
    'dbfa442e-6089-452c-8348-0e3d06840f23',
    '5e55be4d-0393-4e64-928d-e24f2bea80fd',
    'cbf3191b-3267-4953-902a-9ba696a7a142',
    'bc507614-8b07-41b6-a00c-daa0d2890350',
    'af3a3503-81aa-4f97-939a-f2efb4601702',
    '165f617a-31d5-4cc4-9495-8304e049ba2f',
    '1d6207d3-7bf0-4a1c-99f5-82af61572775',
    '04ab0748-479b-4654-9822-51604b859081', // wholeFoods
];
